import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé el cumpleaños de mi hija de 5 años en una tarde. Los checklist y el cronograma me ahorraron semanas de estrés. ¡Quedó mejor que uno de salón!',
  name: 'Mariela G.',
  location: 'Córdoba',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/0c23aea5-3f2e-47f7-a373-1cd66d72c009.jpg'
}, {
  quote: 'El tomo de presupuesto fue un golpe de realidad increíble. Aprendí a comprar inteligente y ahorré más del 40%. El resultado fue una fiesta soñada.',
  name: 'Laura P.',
  location: 'Rosario',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/ee8fd946-e095-4b57-b69b-5d58df91a22e.jpg'
}, {
  quote: 'Los juegos por edad son un genio. Por primera vez en 3 cumpleaños no hubo llantos ni peleas. El tomo de decoración DIY vale cada peso pagado.',
  name: 'Romina M.',
  location: 'Buenos Aires',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/aeb6cd57-640b-4b34-a310-33dd79f27e66.jpg'
}];
export function Testimonials() {
  return <section aria-label="Testimonios" className="bg-ink" data-id="element-145" data-mp="m2ydyndqabto">
      <div className="mx-auto max-w-6xl px-5 pt-[47px] py-16 sm:py-20" data-id="element-146" data-mp="78tub113mlxd">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-147" data-mp="c6bthzpbdms6">
          💬 Lo que dicen las mamás que ya lo aplicaron
        </h2>
        <div className="mt-10 grid w-full grid-cols-1 gap-5 sm:mt-12 md:grid-cols-3 md:gap-6" data-id="element-148" data-mp="zyivpfhq0nzi">
          {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex min-h-[230px] flex-col rounded-2xl border border-white/10 bg-ink-2 p-6 sm:min-h-[250px]" data-id="element-149" data-mp="q764mq3qy1uj" data-mpi={i}>
              <div className="flex gap-0.5 text-azure" data-id="element-150" data-mp="1xiirct2b5eh4">
                {Array.from({
              length: 5
            }).map((_, k) => <StarIcon key={k} className="h-4 w-4 fill-current" data-id="element-151" data-mp="1sjz7cy79ycre" data-mpi={k} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-white/80" data-id="element-152" data-mp="1ofzrmhttjhz3">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-153" data-mp="1ej4tw15ddllv">
                <img src={t.img} alt={t.name} className="h-11 w-11 rounded-full object-cover ring-2 ring-iris/50" data-id="element-154" data-mp="19sepaq4rpms8" />
                <div data-id="element-155" data-mp="14r8sag42rdcw">
                  <div className="text-sm font-bold text-white" data-id="element-156" data-mp="10s01nk4bzvlk">{t.name}</div>
                  <div className="text-xs text-white/50" data-id="element-157" data-mp="10px1w8ddmo3n">📍 {t.location}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}